module.exports = __webpack_public_path__ + "img/logo-text.a00db868.png";